import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDGBsjbAiRXwXgMX5pnNzxyvCAaOHFRW_c",
    authDomain: "trpg-sog010.firebaseapp.com",
    projectId: "trpg-sog010",
    storageBucket: "trpg-sog010.firebasestorage.app",
    messagingSenderId: "914824329924",
    appId: "1:914824329924:web:8286fe1b5780e301b32791",
    measurementId: "G-7ZD4Z876ZY",
};

// Firebase SDKの初期化
const app = initializeApp(firebaseConfig);

// Firebaseの認証オブジェクトをエクスポート
export const auth = getAuth();
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
